import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppComponent } from '../app.component';
import { environment } from '../../environments/environment';
import { CompanyService } from '../_services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-company',
  templateUrl: './create-company.component.html',
  styleUrls: ['./create-company.component.css'],
})
export class CreateCompanyComponent implements OnInit, OnDestroy {
  model: any = {};
  createCompanyForm: FormGroup;
  appName: any;
  copyright: any;
  subscriptionId: string;
  isLoading: boolean = false;
  newCompanyCreated = false;

  constructor(
    private fb: FormBuilder,
    private appComponent: AppComponent,
    private companyService: CompanyService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private translateService: TranslateService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.subscriptionId = params['idSubscription'];
    });
  }

  ngOnInit() {
    this.CreateCompanyForm();
    this.appComponent.setTitle('Create Company');
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login-two');
    this.appName = environment.projectName;
    this.copyright = environment.copyright;
    this.getIfCompanyAlreadyExists();

    history.pushState(null, '', location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  getIfCompanyAlreadyExists() {
    this.companyService
      .getIfCompanyAlreadyExists(this.subscriptionId)
      .subscribe({
        next: (response) => {
          this.router.navigate(['/']);
        },
      });
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-two');
    window.onpopstate = null;
  }

  CreateCompanyForm() {
    this.createCompanyForm = this.fb.group({
      SubscriptionId: [
        { value: this.subscriptionId, disabled: true },
        [Validators.required],
      ],
      CompanyName: ['', [Validators.required]],
      Address: ['', [Validators.required]],
      Phone: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      Email: ['', [Validators.required, Validators.email]],
    });
  }

  createCompany() {
    if (this.createCompanyForm.invalid) {
      this.createCompanyForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.newCompanyCreated = true;

    this.companyService
      .createCompanyWithoutToken(this.createCompanyForm.value)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.newCompanyCreated = true;
        },
        error: () => {
          this.isLoading = false;
          this.toastrService.error(
            this.translateService.instant(
              'createEnterprise.errorOnCreateCompany'
            ),
            'Error'
          );
        },
      });
  }
}
